<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconHelpRound_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M21.986 12c0 5.523-4.474 10-9.993 10S2 17.523 2 12 6.474 2 11.993 2s9.993 4.477 9.993 10M10.9 8.27a1.996 1.996 0 0 1 3.01 1.728V10c0 .47-.365.958-1.054 1.418a6 6 0 0 1-1.246.628l-.015.005a1 1 0 0 0 .633 1.897L11.913 13l.317.948h.002l.004-.002.01-.004.036-.012.116-.043a8.043 8.043 0 0 0 1.569-.806c.81-.54 1.943-1.55 1.944-3.08l-1-.001h1a4 4 0 0 0-3.322-3.947A3.996 3.996 0 0 0 8.14 8.668a1 1 0 1 0 1.887.663 2 2 0 0 1 .873-1.06M11.992 16a1 1 0 0 0 0 2h.01a1 1 0 1 0 0-2z"
        clip-rule="evenodd"
    />
</svg>
